import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { FormField } from '../../../dto/util/form-field';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-modal-nom-des',
  templateUrl: './modal-nom-des.component.html',
  styleUrl: './modal-nom-des.component.scss',
})
export class ModalNomDesComponent {
  @ViewChild('modalNomDes')
  modalNomDes!: ElementRef;
  dominioForm!: FormGroup;
  nomDesForm: FormField[] = [
    {
      name: 'nombre',
      label: 'Nombre',
      type: 'text',
      required: true,
      width: '12',
      visible: true,
      errorMessages: {
        required: 'El nombre es requerido',
        pattern:
          'Solo se permiten letras, números y guiones (-). Ejemplo: nombre-1, dos-nombres',
        nameExists: 'Este nombre ya existe',
      },
    },
    {
      name: 'descripcion',
      label: 'Descripción',
      type: 'textarea',
      required: true,
      width: '12',
      visible: true,
      errorMessages: {
        required: 'La descripción es requerida',
      },
    },
  ];

  @Input() conDescripcion: boolean = true;
  @Input() elements: any[] = [];
  @Output() ndEmitter = new EventEmitter<any>();

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.nomDesForm[1].visible = this.conDescripcion;
    const formControls: any = {};
    this.nomDesForm.forEach(field => {
      if (field.visible) {
        formControls[field.name] = [null, []];
      }
    });
    this.dominioForm = this.fb.group(formControls);
  }

  createForm(): void {
    const formControls: any = {};
    this.nomDesForm.forEach(field => {
      if (field.visible) {
        const validators = [];
        if (field.required) {
          validators.push(Validators.required);
        }
        if (field.name === 'nombre') {
          validators.push(Validators.pattern(/^[a-zA-Z0-9-]+$/));
          validators.push(this.uniqueNameValidator(this.elements));
        }
        formControls[field.name] = [null, validators];
      }
    });
    this.dominioForm = this.fb.group(formControls);
  }

  submitForm(): void {
    if (this.dominioForm.valid) {
      this.ndEmitter.emit(this.dominioForm.value);
      this.abrirCerrarModal();
      this.dominioForm.reset();
    } else {
      this.dominioForm.markAllAsTouched();
    }
  }

  getErrorMessage(field: string): string | null {
    const control = this.dominioForm.get(field);
    if (control?.invalid && control.touched) {
      const errorType = Object.keys(control.errors!)[0];
      return (
        this.nomDesForm.find(f => f.name === field)?.errorMessages?.[
          errorType
        ] || 'Campo inválido'
      );
    }
    return null;
  }

  uniqueNameValidator(existingElements: any[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;
      const nameExists = existingElements.some(el => {
        if (typeof el === 'string') {
          return el.toLowerCase() === control.value.toLowerCase();
        } else {
          return el.Nombre.toLowerCase() === control.value.toLowerCase();
        }
      });
      return nameExists ? { nameExists: true } : null;
    };
  }

  abrirCerrarModal() {
    this.createForm();
    this.modalNomDes.nativeElement.click();
  }
}
